import type { Result } from 'neverthrow';

import { apiRequest, type ApiError } from './client';

/**
 * Public-shape Connection metadata as embedded in `GET /tenants/me`.
 * Mirrors `apps/api/src/handlers/get-tenants-me.ts:sanitiseConnection`
 * — never carries the access-token ciphertext, which is internal to
 * the API.
 */
export interface BcConnection {
  readonly connection_id: string;
  readonly kind: 'bigcommerce';
  readonly status: 'pending' | 'active' | 'revoked';
  readonly installed_at?: string;
  readonly bc_store_hash?: string;
  readonly bc_user_email?: string;
  readonly bc_scopes?: string;
}

/**
 * Body for `POST /connections/claim` — the SPA's `/app/bc-claim`
 * route calls this after the merchant signs in following a BC
 * install (ADR 0011). The backend atomically claims an unattached
 * pending Connection for the caller's tenant.
 */
export interface ClaimConnectionRequest {
  readonly connection_id: string;
}

export function claimConnection(
  input: ClaimConnectionRequest,
): Promise<Result<BcConnection, ApiError>> {
  return apiRequest<BcConnection>({
    method: 'POST',
    path: '/connections/claim',
    body: input,
  });
}
